import styles from './Spacer.module.scss';

export default function Spacer({ size = 'sm' }) {
  return <div className={styles[size]} />;
}
